export default __webpack_public_path__ + "static/media/ic_scotland.8ba43e75.svg";